module.exports = __webpack_public_path__ + "img/beer-icon.a95f9fec.svg";